module.exports = __webpack_public_path__ + "static/media/PhoneLeft.110ddc80.png";